export default __webpack_public_path__ + "static/media/time-monochromatic.10ab23c2.svg";